import { PharmacyDownloadDialog, PharmacySelect } from './shared/PharmacyUI';
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import api from '../services/api';
import { IOS } from './shared/MenuLayout';

const ReportModal = ({ open, onClose, datos, parametros }) => {
  const [tipoReporte, setTipoReporte] = useState('ipress');
  const [cargando, setCargando] = useState(null); // null | 'pdf' | 'excel'

  const descargarPDF = async () => {
    if (cargando) return;
    setCargando('pdf');
    try {
      const response = await api.post('/farmacia/almacen/generar-reporte-pdf', {
        datos: datos,
        tipoAgrupacion: tipoReporte,
        parametros: {
          mesesCobertura: parametros.mesesCobertura,
          porcentaje: parametros.porcentaje,
          usuario: parametros.usuario || 'Usuario'
        }
      }, { responseType: 'blob' });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Distribucion_${tipoReporte}_${new Date().getTime()}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
      setTimeout(() => onClose(), 400);
    } catch (error) {
      console.error('Error PDF:', error);
      alert('Error al generar el PDF');
    } finally {
      setCargando(null);
    }
  };

  const descargarExcel = async () => {
    if (cargando) return;
    setCargando('excel');
    try {
      const response = await api.post('/farmacia/almacen/generar-reporte-excel', {
        datos: datos,
        tipoAgrupacion: tipoReporte,
        parametros: {
          mesesCobertura: parametros.mesesCobertura,
          porcentaje: parametros.porcentaje,
          usuario: parametros.usuario || 'Usuario'
        }
      }, { responseType: 'blob' });

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Distribucion_${tipoReporte}_${new Date().getTime()}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
      setTimeout(() => onClose(), 400);
    } catch (error) {
      console.error('Error Excel:', error);
      alert('Error al generar Excel');
    } finally {
      setCargando(null);
    }
  };

  if (!open) return null;

  return <PharmacyDownloadDialog open={open} onClose={onClose} title="Descargar distribución" total={datos.length} busy={!!cargando} options={[{fmt:'pdf',label:'Descargar PDF',onClick:descargarPDF},{fmt:'excel',label:'Descargar Excel',onClick:descargarExcel}]}><Box sx={{mb:2.5}}><PharmacySelect label="Agrupar reporte" w="100%" value={tipoReporte} onChange={e=>setTipoReporte(e.target.value)} disabled={!!cargando}><option value="ipress">Por IPRESS</option><option value="producto">Por producto · detalle de IPRESS</option><option value="producto-resumen">Por producto · solo totales</option></PharmacySelect><Typography sx={{mt:1.5,fontSize:'.76rem',color:IOS.label2}}>{parametros.mesesCobertura} meses de cobertura · {parametros.porcentaje}% de stock</Typography></Box></PharmacyDownloadDialog>;
};

export default ReportModal;